import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useLocation } from 'react-router-dom';

import { useSelector } from 'react-redux';
import { MdFileUpload, MdOutlineArrowRightAlt } from 'react-icons/md';
import { toast } from 'react-toastify';
import api from '../../services/api';
import {
  Actions,
  Button,
  Card,
  Container,
  Header,
  InfoItem,
  InfoLabel,
  InfoList,
  InfoValue,
  SubtitleCard,
  Title,
  TitleCard,
  UploadButton,
  Wrapper,
  WrapperHeader,
} from './styles';
import { opImport } from '../../lib/csv-core';
import history from '../../services/history';
import { AppError } from '../../errors/AppError';

function UpdatePN() {
  const location = useLocation();

  const selectUser = useSelector((state) => state.user);
  const { idEmpresa } = selectUser.profile.empresa;

  const [updatedPN, setUpdatedPN] = useState([]);

  const [partNumberFilter, setPartNumberFilter] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');

  const handleLoadUpdatePN = useCallback(async () => {
    const response = await api.get(`empresa/${idEmpresa}/update-pn`);
    setUpdatedPN(response.data?.updatePN);
  }, [idEmpresa]);

  const filteredCards = useMemo(() => {
    const search = partNumberFilter.trim().toLowerCase();

    return updatedPN.filter((upd) => {
      const matchesPartNumber =
        !search ||
        String(upd.partnumber ?? '')
          .toLowerCase()
          .includes(search);

      const updStatus = Number(upd.updatePNEmpresa?.[0]?.status ?? 0);

      const matchesStatus =
        statusFilter === 'all' || updStatus === Number(statusFilter);

      return matchesPartNumber && matchesStatus;
    });
  }, [updatedPN, partNumberFilter, statusFilter]);

  useEffect(() => {
    handleLoadUpdatePN();
  }, [handleLoadUpdatePN]);

  const handleActionButton = useCallback(
    async (idMaterial, status, partnumber) => {
      try {
        await api.put(`empresa/${idEmpresa}/update-pn/status`, {
          idMaterial: Number(idMaterial),
          partnumber: String(partnumber),
          status: Number(status),
        });

        toast.success('Status atualizado com sucesso!');

        await handleLoadUpdatePN();
      } catch (error) {
        AppError(error);
      }
    },
    [idEmpresa, handleLoadUpdatePN]
  );

  const handleUpload = useCallback(() => {
    history.push('/empresa/update-pn/upload', {
      background: { ...location },
      parametros: {
        op: opImport.UPDATE_PARTNUMBER,
        idEmpresa: Number(idEmpresa),
      },
    });
  }, [idEmpresa, location]);

  return (
    <Container>
      <WrapperHeader>
        <div>
          <Title>Atualizações de Partnumber</Title>
          <input
            type="text"
            value={partNumberFilter}
            onChange={(event) => setPartNumberFilter(event.target.value)}
            placeholder="Buscar por partnumber"
          />
          <select
            value={statusFilter}
            onChange={(event) => setStatusFilter(event.target.value)}
          >
            <option value="all">Todos</option>
            <option value="0">Pendente</option>
            <option value="1">Aprovado</option>
            <option value="2">Recusado</option>
          </select>
        </div>
        <UploadButton
          type="button"
          title="Importar atualizações de partnumbers"
          onClick={handleUpload}
        >
          <MdFileUpload size={22} />
        </UploadButton>
      </WrapperHeader>
      <Wrapper>
        {filteredCards.map((upd) => (
          <Card key={upd.id} $updStatus={upd.updatePNEmpresa[0]?.status}>
            <Header>
              <TitleCard>
                {upd.materialFabricante?.partnumber}{' '}
                <MdOutlineArrowRightAlt size={22} /> {upd.partnumber}
              </TitleCard>
              {upd && <SubtitleCard>{upd.idMaterial}</SubtitleCard>}
            </Header>

            <InfoList>
              <InfoItem key={1}>
                <InfoLabel>Descrição BR</InfoLabel>
                <InfoValue>
                  {upd.materialFabricante?.descricaoBR || '-'}
                </InfoValue>
              </InfoItem>
              <InfoItem key={2}>
                <InfoLabel>Descricao EN</InfoLabel>
                <InfoValue>
                  {upd.materialFabricante?.descricaoEN || '-'}
                </InfoValue>
              </InfoItem>
              <InfoItem key={3}>
                <InfoLabel>Data Criação</InfoLabel>
                <InfoValue>{upd.instinc}</InfoValue>
              </InfoItem>
              <InfoItem key={4}>
                <InfoLabel>Status</InfoLabel>
                <InfoValue $updStatus={upd.updatePNEmpresa[0]?.status}>
                  {['Pendente', 'Aprovado', 'Recusado'][
                    upd.updatePNEmpresa[0]?.status
                  ] || 'Pendente'}
                </InfoValue>
              </InfoItem>
            </InfoList>

            {upd.updatePNEmpresa[0]?.status === 0 && (
              <Actions>
                <Button
                  variant="reject"
                  onClick={() =>
                    handleActionButton(upd.idMaterial, 2, upd.partnumber)
                  }
                >
                  Recusar
                </Button>

                <Button
                  variant="approve"
                  onClick={() =>
                    handleActionButton(upd.idMaterial, 1, upd.partnumber)
                  }
                >
                  Aprovar
                </Button>
              </Actions>
            )}
          </Card>
        ))}
      </Wrapper>
    </Container>
  );
}

export default UpdatePN;
